/**
 * @internal
 */
export const DIFF_VIEW_SEARCH_PARAMETER = 'diffView'

/**
 * @internal
 */
export const DIFF_VIEW_PREVIOUS_DOCUMENT_SEARCH_PARAMETER = 'previousDocument'

/**
 * @internal
 */
export const DIFF_VIEW_NEXT_DOCUMENT_SEARCH_PARAMETER = 'nextDocument'

/**
 * @internal
 */
export const DIFF_SEARCH_PARAM_DELIMITER = ','
